import React from "react";
import {Route, Redirect} from 'react-router-dom'

function ProfesionalRoute({ component: Component, ...rest }) {

    return <Route {...rest} render={(props)=> {

        let userdata = JSON.parse(localStorage.getItem('userdata'));

        if (userdata && userdata.firma && userdata.registro) {
            return <Component />
        }
        return <Redirect to="/home" />
    }} />
}

export default ProfesionalRoute;